
export const SWITCH_RACE = 'SWITCH_RACE';
export const SET_MOBILE = 'SET_MOBILE';
export const SET_ACCOUNT_ID = 'SET_ACCOUNT_ID';
export const GET_RACES = 'GET_RACES';
export const GET_RACE_DETAIL = 'GET_RACE_DETAIL';
export const GET_LEADERBOARD_MEN = 'GET_LEADERBOARD_MEN';
export const GET_LEADERBOARD_WOMEN = 'GET_LEADERBOARD_WOMEN';
export const TOGGLE_FAVORITE = 'TOGGLE_FAVORITE';
export const GET_RESULTS = 'GET_RESULTS';
export const SEARCH_RESULTS = 'SEARCH_RESULTS';
export const SELECT_EVENT = 'SELECT_EVENT';
export const GET_RUNNER_RESULTS = 'GET_RUNNER_RESULTS';
export const SUBMIT_QUESTION = 'SUBMIT_QUESTION';
export const SET_ADS = 'SET_ADS';
export const SET_BRAND = 'SET_BRAND';
export const SET_THEME = 'SET_THEME';
export const CLEAR_SEARCH_RESULTS = 'CLEAR_SEARCH_RESULTS';
export const SET_SINGLE_EVENT = 'SET_SINGLE_EVENT';
export const STICKY_FULL = 'STICKY_FULL';
export const CHANGE_SORT = 'CHANGE_SORT';
export const UNAUTHORIZED = 'UNAUTHORIZED';



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js